export const UPDATE_CART_ITEMS = "UPDATE_CART_ITEMS";
export const CHECKOUT_CART = "CHECKOUT_CART";